import React, { useState ,useEffect, useCallback, useRef } from "react";
import { FaSearch } from 'react-icons/fa';
import { DateCalendar } from '@mui/x-date-pickers';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Backdrop, CircularProgress, styled } from "@mui/material";
import ToastMessage from "../../utils/mui/righttoptoast";
import api from "../../api/api";
import { debounce } from 'lodash';
import SearchIcon from '@mui/icons-material/Search';
import { useSelector } from "react-redux";
import CustomCalendarHeader from "./CustomCalender";
import { format } from 'date-fns';
import DatePicker from 'react-datepicker';
import openEmrApi from "../../api/openemrapi";
const CustomDateCalendar = styled(DateCalendar)(({ theme }) => ({
  '& .MuiPickersCalendarHeader-label': {
    fontSize: '12px',
  },

  // Style the selected day
  '& .MuiPickersDay-root.Mui-selected': {
    backgroundColor: 'rgba(225, 121, 84, 1)',
    borderRadius: 4, // Square shape
    outline: 'none',
    boxShadow: 'none',
    border: 'none',
  },

  // Hover and focus styles for selected day
  '& .MuiPickersDay-root.Mui-selected:hover': {
    backgroundColor: 'rgba(225, 121, 84, 0.9)',
    outline: 'none',
    boxShadow: 'none',
    border: 'none',
  },

  '& .MuiPickersDay-root:focus.Mui-selected': {
    backgroundColor: 'rgba(225, 121, 84, 1)',
    outline: 'none',
    boxShadow: 'none',
    border: 'none',
  },

  // Remove default focus ring from any day cell
  '& .MuiPickersDay-root:focus': {
    outline: 'none',
    boxShadow: 'none',
  }
}));


const NewAppointments = ({ Appointments, setNewAppointments ,selectedAppointment,fetchScheduleData}) => {
  const [dob, setDob] = useState("");
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const currentDate = useSelector((state) => state.filter.currentDate);
  const[futureSlotsData,setFutureSlotsData]=useState([])
    //  const [selectedProvider, setSelectedProvider] = useState("");
    //   const [selectedAppointmentType, setSelectedAppointmentType] = useState("");
   const [selectedDate, setSelectedDate] = React.useState(dayjs());
   const [note, setNote] = useState("");
   const [provider, setProvider] = useState("");
  const [appointmentType, setAppointmentType] = useState("");
   const [openToast, setOpenToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastSeverity, setToastSeverity] = useState('success');
   const[appointmentname,setAppointmentName]=useState('')
   const[slotsdata,setSlotsData]=useState([])
   const [selectedSlot,setSelectedSlot]=useState('')
  const [providersList,setProviderslist]=useState([])
  const[appointmenttypes,setAppointmentTypes]=useState([])
  const [deleteloading,setDeleteloading]=useState(false)
  const[createloading,setCreateLoading]=useState(false)
  const [providername,setProvidername]=useState('');
  const practiseid = window.getPracticeId();
  const [fetchedData, setFetchedData] = useState([]);
  const[loading,setLoading]=useState(false)
  const [selectedPatientid, setSelectedPatientid] = useState(null); 
  const suggestionsRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestionData, setSuggestions] = useState([]);
  const handleNoteChange = (event) => {
    setNote(event.target.value);
  };
   const userConfig = useSelector((state) => state.userconfig);
  
    const clearAllStates = () => {
        setProvidername('');
        setAppointmentName('');
        setProvider('');
        setAppointmentType('');
        setSelectedSlot('');
        setFirstName('');  // Set first name from fetchedData
    setLastName(''); 
    setEmail('');
    setDob('');
    setSelectedPatientid('')
    setSearchTerm('')
    setFetchedData([])
    };

const highlightedDates = React.useMemo(() => {
  if (!futureSlotsData?.length) return [];

  return futureSlotsData
    .filter(
      (item) =>
        item.is_available === true &&
        item.date &&
        dayjs(item.date).isValid()
    )
    .map((item) => dayjs(item.date));
}, [futureSlotsData]);

    const handleSuggestionClick = (item) => {
      if(practiseid==1111){
             setSearchTerm(item.fname+' '+item.lname); // Clear search input
      setShowSuggestions(false); // Hide suggestions
      setSuggestions([]); // Clear suggestions list       
      // fetchDashboardData(item.patientid)

     const selectedPatient = fetchedData.find(patient => patient.id === item.id);

  if (selectedPatient) {
    setFirstName(selectedPatient.fname || '');  // Set first name from fetchedData
    setLastName(selectedPatient.lname || ''); 
    setEmail(selectedPatient.email || '');
    setDob(selectedPatient.DOB || '');
    setSelectedPatientid(selectedPatient.id)
  }
      }else{

         setSearchTerm(item.firstname+' '+item.lastname); // Clear search input
      setShowSuggestions(false); // Hide suggestions
      setSuggestions([]); // Clear suggestions list       
      // fetchDashboardData(item.patientid)

     const selectedPatient = fetchedData.find(patient => patient.patientid === item.patientid);

  if (selectedPatient) {
    setFirstName(selectedPatient.firstname || '');  // Set first name from fetchedData
    setLastName(selectedPatient.lastname || ''); 
    setEmail(selectedPatient.email || '');
    setDob(selectedPatient.dob || '');
    setSelectedPatientid(selectedPatient.patientid)
  }
      }
     

    };

    // useEffect(() => {
    //   if (searchTerm) {
    //     fetchDashboardData(searchTerm);  // Call when the search term changes
    //   }
    // }, [searchTerm]);

    const handleSearch = (e) => {
      const query = e.target.value.toLowerCase();
      setSearchTerm(query);    
      fetchSearchResults(query); // Fetch results based on input
      if (!query) {
        setShowSuggestions(false);
        setSuggestions([]);
      } else {
        setShowSuggestions(true); // Show suggestions if there's input
      }
    };

    const fetchSearchResults = useCallback(
      debounce(async (query) => {
        if (!query) {
          setSuggestions([]);
              return;
        }
        try {
          // const response = await api.post(`/v1/${practiseid}/autocomplete/dssearch`, {
          //   "searchtxt": query
          // });
          let payload = {
      appointmentdate: currentDate,
   searchflag: /^\d+$/.test(query) ? Number(query) : query,
      dashfilter:  null ,
      filterarr: [],
      start: 0,
      limit: 0,
    };
    let response;
    if(practiseid==1111){
          response = await openEmrApi.post(
  "/patient/get/",
  {
    apikey: "bmkxeyjfqpwapjqedzj",

    searchflag:/^\d+$/.test(query) ? Number(query) : query,
  },
  {
    headers: {
      "Content-Type": "application/json",
    },
  }
);
    }else{
         response = await api.post(
              `/v1/${practiseid}/appointments/dashboard`, payload
            );
    }

             if (response.status === 200 && response.data) {
            setSuggestions(response.data || []);
               const newData = response.data || [];
       setFetchedData(newData);  
            setShowSuggestions(true);
          }
        } catch (error) {
          console.error('Error fetching search results:', error);
          setShowSuggestions(false);
          setSuggestions([]);
        }
      }, 500),
      [] // Add dependencies
    );
      
    let payload = {
      appointmentdate: currentDate,
      searchflag: null,
      dashfilter:  null ,
      filterarr: [],
      start: 0,
      limit: 0,
    };

    // const fetchDashboardData = async (searchflag) => {
    //   setLoading(true)
    //    if(searchflag){
    //     payload.searchflag=searchflag
    //   }
    //       try {
    //         const response = await api.post(
    //           `/v1/${practiseid}/appointments/dashboard`, payload
    //         );
    //         if (response.status === 200) {
    //           const newData = response.data || [];
    //             setFetchedData(newData);   
    //         }
    //         else{
    //           setFetchedData([])
    //         }
    //       } catch (error) {
    //         console.log('Error fetching dashboard data:', error);
    //         setFetchedData([])
    //       }finally{
    //   setLoading(false)
    //   payload.searchflag=null
      
    //       }
    // };

    const getProviderOpenslots=async(id,dt)=>{
        console.log("provideridOS",id)
        setFutureSlotsData([])
        try {
          const response=await api.post(`/v1/${practiseid}/provider/futureopenslots`,{
          "providerid": id,
          "startdate": dt
          })
          if(response.status===200){
            setFutureSlotsData(response?.data ?? []);
          }else{
            console.log("Unexpected response :");
          }
        } catch (error) {
          console.log(error)
        }
    }


    const getProviders=async()=>{
      try {
        const response=await api.get(`/v1/${practiseid}/providers`)
        if(response.status===200){
          setProviderslist(response.data)
          const providerIds = response.data.map(provider => provider.providerid);
          const appresponse=await api.post(`/v1/${practiseid}/appointment/types`,{
            "providerid":providerIds
        })
      
        if(appresponse.status===200){
           setAppointmentTypes(appresponse.data)
         if(appresponse?.data?.length){
          // setAppointmentType(appresponse?.data[0]?.value)
          // setAppointmentName(appresponse?.data[0]?.appointmenttypeid)
         }
        
        }else{
          setAppointmentTypes([])
        }
        }else{
          setProvider([])
        }
        if(response?.data?.length){
          // setProvider(response?.data[0]?.providerid)
          // setProvidername(response?.data[0]?.providername)
          await getslots(response?.data[0]?.providerid,selectedDate.format('YYYY-MM-DD'))
              }
    
    
      } catch (error) {
        
      }finally{
      }
    }
    
    const getslots=async(id,dt)=>{
      // console.log("id",id)
      // console.log("dt",dt)
        try {
          const response=await api.post(`/v1/${practiseid}/scheduler/openslots`,{
          "providerid": id,
          "startdate": dt
          })
          if(response.status===200){
           
            setSlotsData(response.data)
          }else{
            setSlotsData([])
          }
        } catch (error) {
          console.log(error)
        }
    }
    
    const providerChange = async (e) => {
      setProvider(e);

      if (e === "") {
        setProvider('');
        setProvidername('');
        setFutureSlotsData([])
        setSlotsData([]);  // Clear the available slots
        return;  // Do not proceed with fetching slots
      }
      
      console.log("Provider selected:", e);  // Check the value of e
      const selectedProvider = providersList.find((item) => item.providerid == e);
      
      if (selectedProvider) {
   
        setProvidername(selectedProvider?.providername);
        console.log("Provider set:", e);  // Ensure provider is set correctly
        await getProviderOpenslots(e, selectedDate.format("YYYY-MM-DD"));
        getslots(e, selectedDate.format("YYYY-MM-DD"));
      } else {
        console.error("No matching provider found.");
      }
    };
    
    const appointmentChange=(e)=>{
      setAppointmentType(e)
      const selectedAppointmentname=appointmenttypes.find((item)=>item.value==e)
       setAppointmentName(selectedAppointmentname?.appointmenttypeid)
    }
    useEffect(() => {
      if (!appointmentType || !providersList?.length) return;
    
      // run only when provider NOT selected
      if (providername) return;
    
      const apptPrefix = appointmentType.trim().slice(0, 3).toLowerCase();
    
      if (apptPrefix === "art") {
        const matchedProvider = providersList.find((p) => {
          const provPrefix = p?.providername?.trim().slice(0, 3).toLowerCase();
          return provPrefix === "art";   // case-insensitive match
        });
        console.log("Matched provider for ART:", matchedProvider);
    
        if (matchedProvider) {
          setProvider(matchedProvider.providerid);
          setProvidername(matchedProvider.providername);
        }
      }
    }, [appointmentType, providersList]);
      const handleDateChange = async(newDate) => {
        setSelectedDate(newDate);  // Update the selected date state
         const selectedProvider = providersList.find((item) => item.providername == providername);
        await getslots(String(selectedProvider?.providerid || ""),newDate.format('YYYY-MM-DD'))
        await getProviderOpenslots(String(selectedProvider?.providerid || ""),newDate.format('YYYY-MM-DD'));
    };
    
      const handleToastClose = () => {
        setOpenToast(false);
    };

    useEffect(()=>{
       getProviders();
    },[])




    // console.log('SlectedId',selectedPatientid)

    const createappointment=async(selectedPatientid, { AppointmentNote })=>{
   
        if(!appointmentType){
        setToastMessage('Please Select Appointment Type');
        setToastSeverity('error');
        setOpenToast(true);
        return
        }
      if(!provider){
        setToastMessage('Please Select Provider');
        setToastSeverity('error');
        setOpenToast(true);
        return
      }
      if (!selectedSlot) {
        setToastMessage('Please Select Time Slot');
        setToastSeverity('error');
        setOpenToast(true);
        return;
      }
      try {
        setCreateLoading(true)
          
       let response;
          if (practiseid == 1111) {
  console.log(slotsdata);
  console.log(selectedSlot, 'app');

  // find selected slot index
  const index = slotsdata.findIndex(s => s.starttime === selectedSlot);
  if (index === -1) {
    setCreateLoading(false);
    return;
  }

  // helpers
  const toDate = (date, time) => {
    const [h, m] = time.split(":").map(Number);
    const d = new Date(date);
    d.setHours(h, m, 0);
    return d;
  };

  const formatDateTime = d => {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");

    let hh = d.getHours();
    const ampm = hh >= 12 ? "PM" : "AM";
    hh = hh % 12 || 12;

    return `${yyyy}-${mm}-${dd} ${hh}:${String(d.getMinutes()).padStart(2, "0")} ${ampm}`;
  };

  // start & end slots
  const startSlot = slotsdata[index];
  const endSlot = slotsdata[index + 1] || startSlot;

  const startDateObj = toDate(startSlot.startdate, startSlot.starttime);
  const endDateObj = toDate(endSlot.startdate, endSlot.starttime);

  // ✅ DEFINE minutesDuration
  const minutesDuration = Math.max(
    (endDateObj - startDateObj) / 60000,
    15
  );

  const startDatetime = formatDateTime(startDateObj);
  const endDateTime = formatDateTime(endDateObj);
console.log(selectedAppointment,'selected appointment')
  response = await openEmrApi.post(`/scheduler/create/`, {
    apikey: "bmkxeyjfqpwapjqedzj",
    patientid: selectedPatientid,
    purpose: appointmentType,
    startDatetime,
    endDateTime,
    minutesDuration,
    purpose_id: appointmentname,
    providerid: provider
  });
}

          else{
  const user=await api.get('/auth/me');
         response=await api.post(`/v1/${practiseid}/scheduler/patient/${selectedPatientid}/create_schedule`,{
          "departmentid":user?.config?.departmentid,
          "startdate": selectedDate.format('YYYY-MM-DD'),
          "starttime": selectedSlot,
          "provider": providername,
          "providerid": provider,
          "appointmenttype": appointmentType,
          "appointmenttypeid": appointmentname,
          "notes":AppointmentNote
          
      })

          }
 
      if(response.status==200){
        setToastMessage('Appointment created successfully!');
        setToastSeverity('success');
        setOpenToast(true);

        // Close the modal after appointment is created successfully
        setTimeout(() => {
            setNewAppointments(false); // Close the modal
        }, 1000); // Delay to allow the toast to show

        // Reset all states after successful appointment creation
        clearAllStates();

        // Fetch the updated schedule data
        fetchScheduleData();

        setTimeout(() => {
            setOpenToast(false);
        }, 4000);
      }else{
        setToastMessage('Failed to create schedule. Please try again.');
        setToastSeverity('info');
        setOpenToast(true);
      }
        
      } catch (error) {
        console.log(error)
        setToastMessage('Something Went Wrong');
        setToastSeverity('error');
        setOpenToast(true);
      }finally{
      setCreateLoading(false)
      }
    }
const handleCreateAppointmentClick = () => {
  if (!selectedPatientid) {
    setToastMessage('Please enter patient details');
    setToastSeverity('error');
    setOpenToast(true);
    return;
  }
   if (!provider) {
    setToastMessage('Please select a provider');
    setToastSeverity('error');
    setOpenToast(true);
    return;
  }
     if (!appointmentType) {
    setToastMessage('Please select an appointment type');
    setToastSeverity('error');
    setOpenToast(true);
    return;
  }
   if (!selectedSlot) {
    setToastMessage('Please select a time slot');
    setToastSeverity('error');
    setOpenToast(true);
    return;
  }

  // If both are present, proceed
 createappointment(selectedPatientid, { AppointmentNote: note });
};


  if (!Appointments) return null;

  const handleCloseAppointmentModal=()=>{
    setNewAppointments(false)
    setProvider('')
    setAppointmentType('')
    clearAllStates()
    }

const isProviderMatched = (typeof provider === 'string' && 
    (provider.includes("Leanora") || 
     provider.includes("Reshma") || 
     ['15', '17'].includes(provider))) ||
    (Array.isArray(provider) && provider.some(p => p === "Leanora" || p === "Reshma"));

  if (!isProviderMatched) {
    console.log("No matching provider found.");
  }

  return (
    <div className="fixed inset-0 overflow-y-auto custom-scrollbar bg-black bg-opacity-50 flex items-center justify-center z-50">
      {/* Popup Box */}
      <div className="relative flex flex-col gap-2 w-[100%] sm:w-auto bg-white  rounded-lg shadow-lg text-left overflow-y-auto custom-scrollbar max-h-[98vh] " >
        <div className=" bg-[#E179545E] p-2 py-3 ">
          <div className="w-full flex items-center justify-between">
            {/* Header */}
            <span className="ml-2 font-semibold text-[#1D2951] text-base text-center tracking-[0] leading-[normal] whitespace-nowrap">
            Create New Appointment
            </span>
            {/* Close Button */}
        
          </div>
        </div>
        <div className="p-3">
        <div className="flex-1 min-w-[250px] max-w-[388px] relative">
            <div className="relative flex items-center bg-gray-100 border border-gray-300 rounded py-1 px-2">
              <SearchIcon 
                     
              className="text-neutral-500" />
              <input
                type="text"
                placeholder="Enter Patient Name or ID"
                className="w-full text-sm bg-transparent border-none outline-none pl-2 text-neutral-700"
                value={searchTerm}
                onChange={handleSearch}
              />
              
            </div>
            {showSuggestions && suggestionData.length > 0 && (
            <div 
            ref={suggestionsRef}
            className="absolute z-10 w-full bg-white border border-neutral-300 text-start  rounded mt-1 max-h-60 overflow-y-auto">
           {/* {suggestionData.map((item) => (
  <div
    key={item.patientid} // Use unique patient ID for the key
    className="p-2 cursor-pointer font-semibold text-[#989898] text-sm transition-colors duration-200 hover:bg-neutral-100 hover:text-blue-600"
    onClick={() => handleSuggestionClick(item)}
  >
    {item.firstname} {item.lastname} - {item.patientid}
  </div>
))} */}
{suggestionData.map((item) => {
  const isOpenEmr = practiseid == 1111;

  const patientId = isOpenEmr ? item.id : item.patientid;
  const firstName = isOpenEmr ? item.fname : item.firstname;
  const lastName = isOpenEmr ? item.lname : item.lastname;

  return (
    <div
      key={patientId}
      className="p-2 cursor-pointer font-semibold text-[#989898] text-sm transition-colors duration-200 hover:bg-neutral-100 hover:text-blue-600"
      onClick={() => handleSuggestionClick(item)}
    >
      {firstName} {lastName} - {patientId}
    </div>
  );
})}


            </div>
          )}
         </div>
        </div>
  




        {/* Input fields */}
<div className="grid grid-cols-1 sm:grid-cols-2 gap-6 px-4">
          {/* First Name */}
          <div className="w-full ">
            <label className="block text-sm font-medium text-[#232323] mb-2" htmlFor="firstName">
              First Name
            </label>
            <input
             value={firstName}  // Use the state variable
             onChange={(e) => setFirstName(e.target.value)}
              type="text"
              id="firstName"
              disabled
              placeholder="FirstName"
              className="w-full min-w-[300px] pl-4 py-1 px-4 rounded-[10px] border-[1px] border-[#DFEAF2] bg-white shadow-[0px_2px_4px_0px_rgba(66,80,102,0.10)]"
            />
          </div>
     {/* DOB */}
            <div className="w-full ">
            <label className="block text-sm font-medium text-[#232323] mb-2" htmlFor="lastName">
              Last Name
            </label>
            <input
              type="text"
              id="lastName"
              value={lastName} 
              disabled
              // Use the state variable
                onChange={(e) => setLastName(e.target.value)}
                placeholder="LastName"
              className="w-full min-w-[300px] pl-4 py-1 px-4 rounded-[10px] border-[1px] border-[#DFEAF2] bg-white shadow-[0px_2px_4px_0px_rgba(66,80,102,0.10)]"
            />
          </div>
          <div className="w-full relative">
            <label className="block text-sm font-medium text-[#232323] mb-2" htmlFor="dob">
              Date of Birth
            </label>
            <div className="">
             <DatePicker
       selected={dob ? dayjs(dob).toDate() : null}
        onChange={(date) => setDob(date)}
            placeholderText="MM/DD/YYYY"
        dateFormat="MM/dd/yyyy"
        className="w-full pl-4 min-w-[300px] py-1 px-4 rounded-[10px] border-[1px] border-[#DFEAF2] bg-white shadow-[0px_2px_4px_0px_rgba(66,80,102,0.10)]"
        disabled
      />
            </div>
          </div>

          {/* Last Name */}
          <div className="">
            <label className="block text-sm font-medium text-[#232323] mb-2" htmlFor="email">
              Email
            </label>
            <input
              type="email"
              id="email"
              value={email} 
              disabled
              // Bind to email state
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              className="w-full min-w-[300px] pl-4 py-1 px-4 rounded-[10px] border-[1px] border-[#DFEAF2] bg-white shadow-[0px_2px_4px_0px_rgba(66,80,102,0.10)]"
            />
          </div>
        </div>
        <div className="w-full flex flex-col sm:flex-row px-4">
    <div className="w-full sm:w-[50%]">
    <label
      className="block text-sm font-medium text-[#232323] mb-2"
      htmlFor="dob"
    >
      Appointment Date
    </label>
    <div className="w-[90%]">
<LocalizationProvider dateAdapter={AdapterDayjs}>
    <CustomDateCalendar
      value={selectedDate}
      onChange={handleDateChange}
      minDate={dayjs()}
      sx={{
        width: '260px',
        height: '300px',
      }}
      dayOfWeekFormatter={(date) => date.format('dd')}
      slots={{
        calendarHeader: CustomCalendarHeader,

        day: (props) => {
          const { day, selected, ...other } = props;

          const isHighlighted = highlightedDates.some((d) =>
            dayjs(d).isSame(dayjs(day), 'day')
          );

          return (
            <PickersDay
              {...other}
              day={day}
              selected={selected}
              sx={{
                ...(isHighlighted && {
                  backgroundColor: '#2e7d32 !important',
                  color: '#fff !important',
                  borderRadius: '50%',

                  '&:hover': {
                    backgroundColor: '#1b5e20 !important',
                  },
                }),
              }}
            />
          );
        },
      }}
    />
</LocalizationProvider>

    </div>
     </div>
  <div className="flex flex-col  justify-start w-full sm:w-[50%] ">
    <p className="font-inter text-sm my-0 text-left px-1">Select Provider</p>
    <select
    id="providers"
    value={provider || ''}
    onChange={(e) => providerChange(e.target.value)}
    className="h-10 px-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
  >
<option value="">Select Provider</option>
    {providersList.map((providerItem) => (
      <option key={providerItem.providerid} value={providerItem.providerid}>
        {providerItem.providername}
      </option>
    ))}
  </select>

<p className="text-sm font-inter my-1 text-left">Appointment type</p>
<select
    id="appointmentType"
    value={appointmentType}
    onChange={(e) => appointmentChange(e.target.value)}
    className="h-10 px-2 text-sm border border-gray-300  rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
  >
 <option value="">Select Appointment Type</option>
    {appointmenttypes.map((type, index) => (
      <option key={index} value={type?.value}>
        {type?.value}
      </option>
    ))}
  </select>
<div className="flex flex-col">
  <div className='font-inter text-left text-[15px]  mb-1 mt-2 text-[#50869A]'>
    Time Slots
  </div>
  {/* Conditionally render the time slots section */}
  {provider && slotsdata.length > 0 ? (
    <div className="grid grid-cols-3 sm:grid-cols-3 gap-2 w-full items-center justify-center">
      {slotsdata.map((slot) => (
        <button
          onClick={() => setSelectedSlot(slot.starttime)}
          key={slot.starttime}
           className={`px-2 py-1 sm:px-4 sm:py-2 text-xs sm:text-sm font-semibold border-[1.5px] border-[#50869A] rounded-md
    ${slot.appointment_count <= 2
      ? 'bg-[#DCFCE7]'
      : slot.appointment_count <= 4
      ? 'bg-[#FFEDD4]'
      : 'bg-[#FFE2E2]'}
    ${selectedSlot === slot.starttime ? ' text-[#50869A] bg-gray-200' : 'hover:bg-gray-200 text-[#50869A]'}
    focus:ring-2 focus:ring-gray-200 focus:outline-none`}
    disabled={slot.appointment_count >= 1}
        >
          {slot.starttime} {/* Display the start time */}
           {slot.appointment_count > 0 && (
    <span className="ml-2 font-normal">({slot.appointment_count})</span>
  )}
        </button>
      ))}
    </div>
  ) : provider && slotsdata.length === 0 ? (
    <p className="text-md text-gray-500 bg-gray-100 px-4 py-2 rounded">
      No open slots available for this provider!
    </p>
  ) : (
    <p className="text-md text-gray-500 bg-gray-100 px-2 py-2 rounded">
      Please select a provider to see available slots.
    </p>
  )}
</div>

    </div>
    
          </div>

         <div className="w-full px-4">
          <label
            className="block text-sm font-medium text-[#232323] mb-1"
            htmlFor="note"
          >
            Notes
          </label>
          <textarea
            id="note"
            rows="2"
            value={note} // Set textarea value from state
           onChange={handleNoteChange} // Update state on input change
            className="w-full pl-4 py-2 rounded-[15px] border-[1px] border-[#DFEAF2] bg-white shadow-[0px_2px_4px_0px_rgba(66,80,102,0.10)]"
            placeholder="Add any additional notes here..."
          ></textarea>
        </div>

        {/* Update Button */}
        <div className="w-full flex justify-end pb-2 px-4 gap-2">
        <button  onClick={handleCloseAppointmentModal}

            className="rounded py-2 px-4 font-inter text-[12px] border-[1.5px] border-gray-200 font-inter transition duration-300 ease-in-out "
          >
             Cancel
          </button>
          <button   onClick={handleCreateAppointmentClick}
            className="rounded py-2 px-4 text-[12px] font-inter transition duration-300 ease-in-out shadow-[0px_4px_4px_#00000040] bg-[#18181B] text-[#FFFFFF]"
          >
      Create Appointment
          </button>
        </div>
      </div>
       <Backdrop
                             sx={{
                               color: 'secondary.main', // Sets the CircularProgress color to secondary
                               backgroundColor: 'rgba(255, 255, 255, 0.5)', // Semi-transparent white background
                               zIndex: (theme) => theme.zIndex.drawer + 1
                             }}
                             open={createloading}
                           >
                             <CircularProgress color="secondary" />
                           </Backdrop>

      <ToastMessage
          message={toastMessage}
          severity={toastSeverity}
          open={openToast}
          handleClose={handleToastClose}
                     />
    </div>
  );
};

export default NewAppointments;